module.exports = __webpack_public_path__ + "img/headerlogoog.960988a4.webp";